/*
 * @Author: yaoyc
 * @since: 2021-07-31 17:01:19
 * @LastAuthor: yaoyc
 * @lastTime: 2021-08-01 22:54:35
 * @FilePath: /app-client-p/src/utils/upload.ts
 * @Description:
 */
import { PickerResult } from './PicOrCameraManager';
import { isIos } from '../AppEvent';
import ReactBlobUtil, { UploadKey } from './ReactBlobUtil';
import { CryptEngine } from './CryptEngine';
import { Str_FileSizeLimit, Str_NoSupportFileType } from '../language/string_res';
import { Platform } from 'react-native';
import * as imSdk from '../../imsdk/api';
import RNFS from './shims/react-native-fs';


export interface UploadProgressImageCallback {
	onSuccess?: (url: string) => void;
	onFail?: (msg?: string) => void;
}
//七牛 ?vframe/jpg/offset/1，拼接在视频链接后可以获取视频第一帧
//七牛 ?avinf，拼接在视频链接后可以获取视频所有信息。
//七牛 ?imageView2/1/w/100/h/200/q/20 拼接在图片链接后可以对图片进行处理,w/100/h/200这两个是控制图片尺寸，q/20 图片进行质量压缩
//?imageInfo 拼接在图片链接后获取图片信息
// http://78re52.com1.z0.glb.clouddn.com/docs/v6/api/reference/fop/image/imageinfo.html
export const uploadProgressFile = async (
	response: PickerResult,
	sender: number,
	cid: string,
	docSize?: number,
): Promise<{ code: number; cid: string; msg?: string; url?: string ,docSize?: number,}> => {
	return uploadFiles(UploadKey.Chat, response, sender, cid,docSize);
};

// 上传函数
const uploadFiles = async (key: UploadKey, response: PickerResult, sender: number, cid: string, docSize?: number) => {

	let filePath: string;
	let filetype: string;
	filePath = response.path;
	// 从 mimeType 获取文件类型

	// 兜底推断 mimeType
	let mimeType = response.mimeType || '';
	if (!mimeType && response.fileName) {
	  const ext = response.fileName.split('.').pop()?.toLowerCase();
	  const mimeMap: { [key: string]: string } = {
		 'pdf': 'application/pdf',
		 'doc': 'application/msword',
		 'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		 'xls': 'application/vnd.ms-excel',
		 'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		 'ppt': 'application/vnd.ms-powerpoint',
		 'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
		 'txt': 'text/plain',
		 'zip': 'application/zip',
		 'rar': 'application/x-rar-compressed',
		 'csv': 'text/csv',
		 'jpg': 'image/jpeg',
		 'jpeg': 'image/jpeg',
		 'png': 'image/png',
		 'gif': 'image/gif',
		 'webp': 'image/webp',
		 'svg': 'image/svg+xml',
	  };
	  mimeType = mimeMap[ext || ''] || '';
	}
	if (!mimeType) {
	  mimeType = 'application/octet-stream';
	}

	// 从 mimeType 或文件名推断真实扩展名
	// 优先从 fileName 取扩展名（最准确），fallback 到 mimeType 简单映射
	const mimeToExt: { [key: string]: string } = {
		'image/jpeg': 'jpg',
		'image/jpg': 'jpg',
		'image/png': 'png',
		'image/gif': 'gif',
		'image/webp': 'webp',
		'image/svg+xml': 'svg',
		'video/mp4': 'mp4',
		'video/quicktime': 'mov',
		'video/webm': 'webm',
		'application/pdf': 'pdf',
		'application/msword': 'doc',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
		'application/vnd.ms-excel': 'xls',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
		'application/vnd.ms-powerpoint': 'ppt',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
		'text/plain': 'txt',
		'text/csv': 'csv',
		'application/zip': 'zip',
		'application/x-rar-compressed': 'rar',
		'application/octet-stream': 'bin',
	};
	if (response.fileName) {
		const dotIdx = response.fileName.lastIndexOf('.');
		filetype = dotIdx > -1 ? response.fileName.slice(dotIdx + 1).toLowerCase() : (mimeToExt[mimeType] || 'bin');
	} else {
		filetype = mimeToExt[mimeType] || 'bin';
	}

	console.info('[BEE-FILE][UPLOAD-START]', key, mimeType, 'filetype:', filetype);
	let maxMetaSizeLimit = imSdk.getInstance().getMediaLimit(key, filetype);
	if (maxMetaSizeLimit <= 0) {
		if (typeof console !== 'undefined') {
			console.error('[BEE-FILE][UPLOAD-ERROR] 不支持的文件类型或大小', { key, response });
		}
		return { code: 0, cid: cid, msg: Str_NoSupportFileType };
	}

	// 获取文件大小：Web 端 blob:/data: URL 用 fetch 获取真实大小，移动端用 RNFS.stat
	let fileSizeBytes = 0;
	if (Platform.OS === 'web') {
		if (response.fileSize && response.fileSize > 0) {
			// 优先使用 PickerResult 中已记录的文件大小（最快）
			fileSizeBytes = response.fileSize;
		} else if (filePath.startsWith('blob:') || filePath.startsWith('data:')) {
			try {
				const r = await fetch(filePath);
				const b = await r.blob();
				fileSizeBytes = b.size;
			} catch (_) {
				fileSizeBytes = 0;
			}
		}
	} else {
		const fileSize = await RNFS.stat(filePath);
		fileSizeBytes = fileSize.size;
	}
	if (fileSizeBytes > maxMetaSizeLimit) {
		if (typeof console !== 'undefined') {
			console.error('[BEE-FILE][UPLOAD-ERROR] 文件超出大小限制', { fileSizeBytes, maxMetaSizeLimit });
		}
		return { code: 0, cid: cid, msg: Str_FileSizeLimit };
	}

	const filemd5 = CryptEngine.md5(response.path);
	// files 数组
	const uri = Platform.OS === 'web' ? filePath : (isIos ? decodeURIComponent(filePath.replace('file://', '')) : filePath);
	// key 生成规则必须与 DocumentRender.tsx 完全一致：sender-cid-md5(decodeURIComponent(cleanPath))
	const cleanPath = decodeURIComponent((filePath || '').replace('file://', ''));
	const k = `${sender}-${cid}-${CryptEngine.md5(cleanPath)}`;
	const uploadParams = {
		path: uri,
		fileName: filemd5,
		filetype: filetype,
		key: key,
		handleKey: k,
		mimeType,
		fileSize: fileSizeBytes,
	};
	if (typeof console !== 'undefined') {
		console.log('[BEE-FILE][UPLOAD-CALL]', uploadParams);
	}
	const res = await ReactBlobUtil.upload(uploadParams);
	if (typeof console !== 'undefined') {
		console.log('[BEE-FILE][UPLOAD-RESULT-RAW]', res);
	}
	return { code: res.code, cid: cid, msg: res.msg, url: res.url };
};

export interface UploadImageManagerCallback {
	onUploadProgress: (progress: number) => void;
	onSuccess: () => void;
	onFail: () => void;
}

class UploadImageManager {
	private mMap = new Map<string, UploadImageManagerCallback>();
	private mProgressMap = new Map<string, number>();

	addProgress(key: string) {
		this.mProgressMap.set(key, 0);
	}

	isUpload(key: string) {
		return this.mProgressMap.has(key);
	}

	getProgress(key: string): number {
		if (this.mProgressMap.has(key)) {
			return this.mProgressMap.get(key) ?? 0;
		}
		return 0;
	}

	addListener(key: string, listener: UploadImageManagerCallback) {
		this.mMap.set(key, listener);
	}

	removeListener(key: string) {
		this.mMap.delete(key);
	}

	handleListener(key: string, progress: number) {
		this.mMap.forEach((v, k) => {
			if (key === k) {
				v.onUploadProgress?.(progress);
				this.mProgressMap.set(key, progress);
			}
		});
	}

	handleSucListener(key: string) {
		this.mMap.forEach((v, k) => {
			if (key === k) {
				v.onSuccess?.();
				this.mProgressMap.delete(key);
			}
		});
	}

	handleFailListener(key: string) {
		this.mMap.forEach((v, k) => {
			if (key === k) {
				v.onFail?.();
				this.mProgressMap.delete(key);
			}
		});
	}
}
export const uploadImageManager = new UploadImageManager();
